import { render, staticRenderFns } from "./birthdate-picker.vue?vue&type=template&id=3d02d89a&scoped=true&"
import script from "./birthdate-picker.vue?vue&type=script&lang=js&"
export * from "./birthdate-picker.vue?vue&type=script&lang=js&"
import style0 from "./birthdate-picker.vue?vue&type=style&index=0&id=3d02d89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d02d89a",
  null
  
)

export default component.exports